import styled from '@emotion/styled'
import { wrapContained as withStyle } from 'utils/styles'

import { ACTIVE } from 'utils/constants'

export default withStyle((props) => {
  const isActive = props.currentStatus === ACTIVE
  return `
    margin-top: ${isActive ? '18px' : '6px'};
  `
})

export const PhaseConnector = styled.path((props) => {
  const { isDisabled, theme } = props

  const { btnPrimaryFocusColor, btnDisabledColor } = theme

  return `
  stroke:${isDisabled ? btnDisabledColor : btnPrimaryFocusColor};
  stroke-width: 1px;
`
})
